import { ScanResult } from './../../../../services/licence-plate-recognition/licence-plate-recognition.model';
import { LicencePlateRecognitionService } from './../../../../services/licence-plate-recognition/licence-plate-recognition.service';
import { AppServerAPI, AppClientConfigurationService } from '@sdbn/common';
import { AreaGateReference, GateKeepingCandidate } from './../../../../gate-keeping.model';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { interval } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-gate-keeper-control-find-element-by-lpr',
    templateUrl: './gkc-find-element-by-lpr.component.html',
    styleUrls: ['./gkc-find-element-by-lpr.component.scss'],
    standalone: false
})
export class GKCFindElementByLprComponent implements OnDestroy {


  @ViewChild('camera') camera!: ElementRef<HTMLVideoElement>;

  @ViewChild('canvasRef') canvasRef!: ElementRef<HTMLCanvasElement>;

  @Input() areaGateReference: AreaGateReference;

  @Output() selectionChanged = new EventEmitter<Array<GateKeepingCandidate>>();

  private cameraStream?: MediaStream;
  private scanSubscription;

  private scanInterval = 1000;

  isLoading = true;

  constructor(
    private appClientConfigurationService: AppClientConfigurationService,
    private appServerAPI: AppServerAPI,
    private licencePlateRecognitionService: LicencePlateRecognitionService
  ) {
    const initializeSubscription = this.licencePlateRecognitionService.initialized.subscribe(initialized => {
      console.log('LPR Service initialized:', initialized);
      this.isLoading = !initialized;
      if (initialized) {
        initializeSubscription.unsubscribe();
      }
    });
    const scanInterval = appClientConfigurationService.getProperty('common.gate-keeper.number-plate-scan-interval');
    if (scanInterval) {
      console.log('Setting LPR scan interval to', scanInterval.value);
      this.scanInterval = Number.parseInt(scanInterval.value);
    }
  }


  ngOnDestroy(): void {
    console.log('LPR destroy');
    this.scanSubscription?.unsubscribe();
    this.stopScanning();
  }


  onDeviceSelected(device: MediaDeviceInfo) {
    navigator.mediaDevices.getUserMedia({ video: { deviceId: { exact: device.deviceId } } }).then(stream => {
      this.cameraStream = stream;
      this.camera.nativeElement.srcObject = stream;
      stream.getTracks().forEach(track => console.log('Using camera track:', track.label, track.getCapabilities()));
      this.startScanning();
    });
  }


  private executeSearch(numberPlate: string) {
    const searchParams = {
      numberPlate: numberPlate,
      gateId: this.areaGateReference.id,
      direction: this.areaGateReference.direction
    };
    this.appServerAPI.execute<Array<GateKeepingCandidate>>('/tmc-common/gate-keeper-app/handleNumberPlate', searchParams).subscribe(response => {
      let candidates = new Array<GateKeepingCandidate>();
      for (let entry of response) {
        candidates.push(new GateKeepingCandidate(entry));
      }
      this.selectionChanged.emit(candidates);
    });
  }

  private startScanning() {
    this.scanSubscription?.unsubscribe();
    const ctx = this.canvasRef.nativeElement.getContext('2d');
    const video = this.camera.nativeElement;
    this.scanSubscription = interval(this.scanInterval).subscribe(async() => {
        if (this.isLoading) {
          return;
        }
        const start = new Date().getTime();
        this.canvasRef.nativeElement.width = video.videoWidth;
        this.canvasRef.nativeElement.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, this.canvasRef.nativeElement.width, this.canvasRef.nativeElement.height);
        console.log('time till canvas paint', new Date().getTime() - start);
        const imageData = ctx.getImageData(0, 0, this.canvasRef.nativeElement.width, this.canvasRef.nativeElement.height);

        const scanResults = await this.licencePlateRecognitionService.detectLicencePlate(imageData);
        console.log('time detection ended', new Date().getTime() - start);
        if (this.licencePlateRecognized(scanResults)) {
          console.log('Plates detected:', scanResults);
          this.executeSearch(scanResults[0].text);
        }
      });
  }


  private licencePlateRecognized(scanResults: ScanResult[]) {
    if (scanResults.length === 0) {
      return false;
    }
    if (scanResults[0].confidence < 0.8 || scanResults[0].text.length < 3) {
      return false;
    }
    return true;
  }

  private stopScanning() {
    this.scanSubscription?.unsubscribe();
    if (this.cameraStream) {
      this.cameraStream.getTracks().forEach(track => track.stop());
      this.cameraStream = undefined;
      this.camera.nativeElement.srcObject = null;
    }
  }

}
